import React, { useState, useEffect } from 'react';
import Icon from '../icons/Icon';
import './BlogSearch.css';

const BlogSearch = ({ onSearch, placeholder = "Search blog posts..." }) => {
  const [searchTerm, setSearchTerm] = useState('');

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      onSearch(searchTerm);
    }, 300);

    return () => clearTimeout(debounceTimer);
  }, [searchTerm, onSearch]);

  const handleChange = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleClear = () => {
    setSearchTerm('');
    onSearch('');
  };

  return (
    <div className="blog-search">
      <div className="blog-search-input-wrapper">
        <span className="blog-search-icon"><Icon name="search" size={18} /></span>
        <input
          type="text"
          className="blog-search-input"
          placeholder={placeholder}
          value={searchTerm}
          onChange={handleChange}
        />
        {searchTerm && (
          <button 
            className="blog-search-clear"
            onClick={handleClear}
            aria-label="Clear search"
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

export default BlogSearch;

